<template>
  <el-row>
    <!-- 左侧导航栏 -->
    <el-col :span="6" class="sidebar">
      <el-menu
          :default-active="selectedMenu"
          class="el-menu-vertical-demo"
          @select="handleSelect"
      >
        <!-- 信息管理 -->
        <el-sub-menu index="1" class="menu-1">
          <template #title>
            <el-icon><Location /></el-icon>
            <span>信息管理</span>
          </template>
          <el-menu-item index="1-1">学员管理</el-menu-item>
          <el-menu-item index="1-2">机构培训计划管理</el-menu-item>
          <el-menu-item index="1-3">机构前端展示列表管理</el-menu-item>
        </el-sub-menu>

        <!-- 资料管理 -->
        <el-sub-menu index="2" class="menu-2">
          <template #title>
            <el-icon><Location /></el-icon>
            <span>资料管理</span>
          </template>
          <el-menu-item index="2-1">考试管理</el-menu-item>
          <el-menu-item index="2-2">视频和图片管理</el-menu-item>
          <el-menu-item index="2-3">考试问题管理</el-menu-item>
        </el-sub-menu>

        <!-- 学习考试管理 -->
        <el-sub-menu index="3" class="menu-3">
          <template #title>
            <el-icon><Location /></el-icon>
            <span>学习考试管理</span>
          </template>
          <el-menu-item index="3-1">学员考试情况</el-menu-item>
          <el-menu-item index="3-2">学员学习情况</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="4" class="menu-4">
          <template #title>
            <el-icon><Location /></el-icon>
            <span>权限管理</span>
          </template>
          <el-menu-item index="4-1">我的权限</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </el-col>

    <!-- 右侧内容区域 -->
    <el-col :span="18" class="content">
      <component
          v-if="isAuthorized"
          :is="currentComponent"
          :userid="userid"
          :organizationID="organizationID"
      />
      <div v-else>
        <p>校验失败，请重新登录。</p>
        <button @click="handleReLogin">重新登录</button>
      </div>
    </el-col>
  </el-row>
</template>


<script>
import QuestionAndAnswer from './ManageView/UserManage.vue';
import QuestionAndAnswer1 from './ManageView/TrainPlan.vue';
import QuestionAndAnswer2 from './ManageView/ShowView.vue';
import testview from './InformationView/TestView.vue';
import testview1 from './InformationView/QuestionView.vue';
import testview2 from './InformationView/VideoAndImageView.vue';
import learn from './LearnView/learnInfor.vue';
import test from './LearnView/UserTestView.vue';
import { useUserStore } from '@/components/user';
import permision from '@/components/ManageView/MyPermision.vue'

export default {
  components: {
    QuestionAndAnswer,
    QuestionAndAnswer1,
    QuestionAndAnswer2,
    testview,
    testview1,
    testview2,
    learn,
    test,
    permision
  },
  data() {
    return {
      isAuthorized: true,
      // userid: this.getQueryParam('userid'), // 从 URL 获取用户 ID
      // organizationID: this.getQueryParam('organizationID'), // 从 URL 获取机构 ID
      // selectedMenu: '1-1',  // 默认选中的菜单项
      selectedMenu: '1-1',  // 默认选中的菜单项
      userid: this.$route.query.userid, // 获取路由中的用户id
      organizationID: this.$route.query.organizationID, // 获取路由中的机构id
      loginuserid:useUserStore().userId
    };
  },

  created() {
console.log('路径的用户id'+this.userid)
    console.log(this.organizationID)
    // this.validatePageAccess()

    const userStore = useUserStore();

    console.log(('pina  里的userid'+userStore.userId))
  },
  computed: {
    // 根据 selectedMenu 显示不同的组件
    currentComponent() {
      switch (this.selectedMenu) {
        case '1-1':
          return 'QuestionAndAnswer';
        case '1-2':
          return 'QuestionAndAnswer1';
        case '1-3':
          return 'QuestionAndAnswer2';
        case '2-1':
          return 'testview';
        case '2-3':
          return 'testview1';
        case '2-2':
          return 'testview2';
        case '3-2':
          return 'learn';
        case '3-1':
          return 'test';
          case '4-1':
          return 'permision';
        default:
          return null;  // 默认不显示任何组件
      }
    },
  },
  methods: {
    // 校验逻辑
    validatePageAccess() {
      const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'+this.loginuserid));

      if (storedUserInfo) {
        const { userID, organizationID } = storedUserInfo;

        // 校验本地存储的值与 URL 中的值是否一致
        if (
            parseInt(userID) === parseInt(this.userid) &&
            parseInt(organizationID) === parseInt(this.organizationID)
        ) {
          this.isAuthorized = true; // 校验通过
        } else {
          this.isAuthorized = false; // 校验失败
        }
      } else {
        this.isAuthorized = false; // 如果未登录，校验失败
      }
    },
    // 从 URL 获取参数
    getQueryParam(param) {
      const url = new URL(window.location.href);
      return url.searchParams.get(param);
    },
    // 处理菜单项选择事件
    handleSelect(index) {
      this.selectedMenu = index;  // 更新选中的菜单项
    },
    // 处理重新登录
    handleReLogin() {
      // 清除本地信息，跳转到登录页面
      localStorage.removeItem('userInfo'+this.loginuserid);

      window.location.href = '/MGLogin'; // 假设有登录页
    },
  },
};
</script>

<style scoped>
/* 左侧导航栏样式 */
.sidebar {
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  background-color: #f4f4f4;
  padding: 20px;
  height: 100vh;
  border-right: 1px solid #ddd;
}

/* 内容区域样式 */
.content {
  padding: 20px;
  background-color: #fff;
  height: 100vh;
  overflow: auto;
}

/* 主菜单样式 */
.el-menu-vertical-demo {
  width: 100%;
  background-color: #f4f4f4;
}

/* 菜单项通用样式 */
.el-menu-item,
.el-sub-menu__title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

/* 活跃菜单项样式 */
.el-menu-item.is-active {
  background-color: #409EFF;
  color: #fff;
}

/* 菜单项悬停样式 */
.el-menu-item:hover {
  background-color: #e0f7ff;
  color: #409EFF;
}

/* 子菜单标题样式 */
.el-sub-menu__title {
  color: #409EFF;
  padding: 10px 20px;
}

/* 给不同的子菜单添加背景色 */
.menu-1 > .el-sub-menu__title {
  background-color: #f0f8ff; /* 浅蓝色背景 */
}

.menu-2 > .el-sub-menu__title {
  background-color: #eafaf1; /* 浅绿色背景 */
}

.menu-3 > .el-sub-menu__title {
  background-color: #fdf2f5; /* 浅粉色背景 */
}

/* 子菜单项之间的间距优化 */
.menu-1 .el-menu-item,
.menu-2 .el-menu-item,
.menu-3 .el-menu-item {
  padding-left: 40px; /* 缩进效果 */
}


</style>
